export enum ExternalOrderProviderVenueMode {
  PROVIDER_DELIVERY = 'provider_delivery',
  OWN_DELIVERY = 'own_delivery',
}
